import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/sales/Hero';
import { PainSection } from '../components/sales/PainSection';
import { TriadaSection } from '../components/sales/TriadaSection';
import { ObjecionesSection } from '../components/sales/ObjecionesSection';
import { EntregablesSection } from '../components/sales/EntregablesSection';
import { ParaQuienSection } from '../components/sales/ParaQuienSection';
import { PrecioSection } from '../components/sales/PrecioSection';
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel - PageView
    if (typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '3099001053617513');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      // Noscript pixel fallback
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=3099001053617513&ev=PageView&noscript=1" />`;
      document.head.appendChild(noscript);
    }
  }, []);
  return <main className="w-full min-h-screen bg-[#FAF3E0]" data-id="element-163">
      <Hero data-id="element-164" />
      <PainSection data-id="element-165" />
      <TriadaSection data-id="element-166" />
      <ObjecionesSection data-id="element-167" />
      <EntregablesSection data-id="element-168" />
      <ParaQuienSection data-id="element-169" />
      <PrecioSection data-id="element-170" />

      {/* Footer */}
      <footer className="w-full bg-[#1B4332] py-8 px-4 text-center" data-id="element-171">
        <p className="text-[#FAF3E0]/60 text-sm" data-id="element-172">
          © 2026 Emalia. Todos los derechos reservados.
        </p>
      </footer>
    </main>;
}